module.exports = __webpack_public_path__ + "img/PM_A04_back_en.59c8b463.png";